(function (window, document) {
    'use strict';

    var embeds = document.querySelectorAll('[data-bmh-deferred-embed]');
    var observer = null;

    function loadEmbed(embed) {
        if (!embed || /^(loading|loaded)$/.test(embed.getAttribute('data-bmh-deferred-state') || '')) {
            return;
        }
        var frame = embed.querySelector('[data-bmh-deferred-frame]');
        var source = frame && frame.getAttribute('data-src');
        if (!source) {
            return;
        }
        embed.setAttribute('data-bmh-deferred-state', 'loading');
        frame.addEventListener('load', function () {
            embed.setAttribute('data-bmh-deferred-state', 'loaded');
            var placeholder = embed.querySelector('[data-bmh-deferred-load]');
            if (placeholder) {
                placeholder.hidden = true;
            }
        }, { once: true, passive: true });
        frame.hidden = false;
        frame.loading = 'lazy';
        frame.src = source;
        frame.removeAttribute('data-src');
        if (observer) {
            observer.unobserve(embed);
        }
    }

    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
                    loadEmbed(entry.target);
                }
            });
        }, { rootMargin: '0px', threshold: [0.2] });
    }

    embeds.forEach(function (embed) {
        var button = embed.querySelector('[data-bmh-deferred-load]');
        if (button) {
            button.addEventListener('click', function () {
                loadEmbed(embed);
            });
        }
        if (observer) {
            observer.observe(embed);
        }
    });
})(window, document);
